<template>
  <section class="invest">
    <div class="invest__content container">
      <div class="invest__logo --fade-in-up" data-vertical-ivp-class="--animate">
        <img src="~@/assets/logo.png" alt="">
      </div>
      <h1 class="invest__title --fade-in-up" data-vertical-ivp-class="--animate">INVEST in GeoSolar Technologies</h1>
      <p class="invest__bold-text --fade-in-up" data-vertical-ivp-class="--animate">
				You can invest in the future of the home. Everyone can invest now for as little as $300 (US).
				By investing in GeoSolar Technologies (GST) you can share in the company's future
				growth while helping to combat the climate crisis.
      </p>
      <a target="_blank" href="GST_offering_circular.pdf" class="--fade-in-up" data-vertical-ivp-class="--animate">
        Potential investors should read the Offering Circular and review risk factors associated with making an investment.
      </a>
      <p class="invest__bold-text --fade-in-up" data-vertical-ivp-class="--animate">	
        You can invest in GeoSolar Technologies any way convenient to you, including by ACH, Wire/Bank Transfer, and
        Credit/Debit Card (GST will cover all fees associated with this method).
      </p>
      <p class="--fade-in-up" data-vertical-ivp-class="--animate">
				This is the first time we are making GST available for public purchase. GeoSolar Technologies Inc. (GST)
				has been qualified by the U.S. Securities and Exchange Commission (SEC) to conduct a Regulation
				A+ capital raise. GST already makes quarterly S1 filings with the SEC
				and is subject to quarterly PCAOB audits. Upon completion of this Regulation A+ offering, we (GST)
				intend to seek listing of our stock on the OTCQB National Market
      </p>
      <p class="invest__bold-text --fade-in-up" data-vertical-ivp-class="--animate">
				The all clean electric home of the future is now available today!
      </p>
    </div>
		<div>
		</div>
  </section>
</template>

<script>

export default {
  name: 'Invest',
  components: {
  },
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/invest.scss";
</style>
